export default function isMarkup(string: string): boolean {
  /** matches anything that isn't a number or letter...
   * which is marginally better than dangerously setting everything */
  const hasSpecialCharacters = /[^a-zA-Z\d\s:]/
  return string && typeof string === 'string'
    ? !!string.match(hasSpecialCharacters)
    : false
}
